import React from 'react';
import { Image } from 'components/atoms/image';

const AwardsOverlayCard = props => {
  const { cardData } = props;
  return (
    <div className={'main'} id={'awardsOverlay'}>
      {cardData.map((item, idx) => {
        return (
          <div className={'award-div'}>
            <div className="award_image">
              <Image src={item.overlay_picture} alt="Award" className="image" />
            </div>
            <div className={'details'}>
              {item.awarded_at !== '0' && (
                <span className="award_date">{item.awarded_at} / </span>
              )}
              <span className="award_date">
                {new Date(item.awarded_on).toString().slice(11, 15)}
              </span>
              <h4 className="award_name">{item.award_name}</h4>
              <h4 className="awards_authority">{item.authority}</h4>
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default AwardsOverlayCard;
